import api from '@/api/api'

import Routes from '@/router/routes'

export default {
	name: 'reports',
	data () {
		return {
			routes : Routes,
			sessionUser : {}
		}
	},
	methods : {},
	components : {},
	created () {

		let vm = this

		vm.sessionUser = JSON.parse( localStorage.getItem('sessionUser') )

	}
}


// WEBPACK FOOTER //
// ./src/components/private/reports/script.js